import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { $getRoot, $isElementNode, $isTextNode } from 'lexical';
export function $setFocusPosition(position) {
    const root = $getRoot();
    switch (position.position) {
        case 'start':
            root.selectStart();
            return;
        case 'end':
            root.selectEnd();
            return;
        case 'index':
            $selectTextOffset(root, Math.min(position.index, root.getTextContent().length));
            return;
        default:
            assertUnreachableValue(position);
    }
}
function $selectTextOffset(node, index) {
    if ($isTextNode(node)) {
        node.select(index, index);
        return;
    }
    if (!$isElementNode(node)) {
        if (index === 0) {
            node.selectStart();
        }
        else {
            node.selectEnd();
        }
        return;
    }
    let remaining = index;
    for (const child of node.getChildren()) {
        const length = child.getTextContentSize();
        if (remaining <= length) {
            $selectTextOffset(child, remaining);
            return;
        }
        remaining -= length;
        const next = child.getNextSibling();
        if ($isElementNode(child) && !child.isInline() && next !== null) {
            // Match getTextContent(): block siblings add two newlines with no node
            // between them. An offset inside that separator belongs to the next block.
            if (remaining < 2) {
                next.selectStart();
                return;
            }
            remaining -= 2;
        }
    }
    node.selectEnd();
}
//# sourceMappingURL=focusPosition.js.map